// Staff Access Report
import { getStorage } from "store/local";
import { startOfMonth, endOfMonth, format } from "date-fns";
// import { getReports } from "apps/Dash/functions";

function layout() {
  const session = getStorage("ctxSession");
  const dom = [["chiefs", "=", session?.user_employee]];
  const ctxView = {
    model: "staff_access.shift_scheduling.report",
    reportName: "staff_access.shift_scheduling.report",
    actionReport: async (store) => {
      if (!store.start_date) {
        store.start_date = format(startOfMonth(new Date()), "yyyy-MM-dd");
      }
      if (!store.end_date) {
        store.end_date = format(endOfMonth(new Date()), "yyyy-MM-dd");
      }
      if (!(Array.isArray(store?.sections) && store.sections.length > 0)) {
        throw new Error("No hay secciones asignadas");
      }
      return store;
    },
    fields: {
      start_date: {
        type: "date",
        required: true,
        default: () => startOfMonth(new Date()),
      },
      end_date: {
        type: "date",
        required: true,
        default: () => endOfMonth(new Date()),
      },
      sections: {
        type: "one2many",
        model: "staff.section",
        required: true,
        layout: {
          selectable: "multi",
          model: "staff.section",
          softDomain: dom,
          table_action: [],
          fields: {
            name: { type: "char" },
          },
          list: [{ name: "name" }],
        },
      },
    },
    list: [],
    form: [
      { name: "start_date" },
      { name: "end_date" },
      {
        name: "sections",
        type: "grid",
        elements: [{ name: "sections" }],
        colSpan: "col-span-2",
      },
    ],
  };
  return ctxView;
}

export { layout };
